<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.21</b> - Небольшие улучшения качества жизни</p>
    <div class="ml-5 pb-4 text-blue-400">
      <div class="font-bold mt-2">Новые возможности</div>
      <ul class="ml-4 list-disc">
        <li>
          Добавлен таймер пополнения магазина и анимация, показывающая прибытие новых товаров.
        </li>
        <li>Добавлена кнопка для показа/скрытия журналов боя в Пещерах.</li>
      </ul>

      <div class="font-bold mt-2">Исправления ошибок</div>
      <ul class="ml-4 list-disc">
        <li>Исправлено несколько ошибок, связанных с закрытием видов комнат в пещерах.</li>
        <li>
          Исправлена ошибка неправильного обновления журналов боя и журналов таверны при получении
          предметов.
        </li>
        <li>Исправлено несколько ошибок отрисовки свечей и молитв в Храме.</li>
      </ul>

      <div class="font-bold mt-2">Производительность</div>
      <ul class="ml-4 list-disc">
        <li>Сглажен переход интерфейса при возвращении на поверхность из Пещер.</li>
      </ul>
    </div>
  </div>
</template>
